import { CloudWatchLoggerConfig, LogLevel } from './cloudwatchLogger';

export const getCloudWatchConfig = (): CloudWatchLoggerConfig => {
    const environment = process.env.REACT_APP_ENV || 'local';

    // Base configuration
    const baseConfig: CloudWatchLoggerConfig = {
        region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
        identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
        userPoolId: process.env.REACT_APP_USER_POOL_ID,

        logGroupName: `/${process.env.REACT_APP_CLOUDWATCH_LOGS_GROUP_NAME}`,
        minLogLevel: getLogLevel('info'),
        batchSize: 10,
        batchTimeout: 5000,
        enableCloudWatchLogs: true,
    };

    // Environment-specific configurations
    switch (environment) {
        case 'local':
            return {
                ...baseConfig,
                minLogLevel: LogLevel.INFO,
                enableCloudWatchLogs: false, // Disable CloudWatch for local development
                batchSize: 1, // Immediate logging for development
                batchTimeout: 1000,
            };

        case 'develop':
        case 'development':
            return {
                ...baseConfig,
                minLogLevel: LogLevel.INFO,
                enableCloudWatchLogs: true,
                batchSize: 5,
                batchTimeout: 3000,
            };

        case 'staging':
            return {
                ...baseConfig,
                minLogLevel: LogLevel.INFO,
                enableCloudWatchLogs: true,
                batchSize: 10,
                batchTimeout: 5000,
            };

        case 'production':
            return {
                ...baseConfig,
                minLogLevel: LogLevel.INFO,
                enableCloudWatchLogs: true,
                batchSize: 20,
                batchTimeout: 10000,
            };

        default:
            return baseConfig;
    }
};

function getLogLevel(levelString: string): LogLevel {
    switch (levelString.toLowerCase()) {
        case 'info':
            return LogLevel.INFO;
        case 'warn':
        case 'warning':
            return LogLevel.WARN;
        case 'error':
            return LogLevel.ERROR;
        default:
            return LogLevel.INFO;
    }
}

// Validate configuration
export const validateCloudWatchConfig = (config: CloudWatchLoggerConfig): string[] => {
    const errors: string[] = [];

    if (!config.region) {
        errors.push('AWS region is required');
    }

    if (config.enableCloudWatchLogs) {
        if (!config.identityPoolId) {
            errors.push('Cognito Identity Pool ID is required when CloudWatch logging is enabled');
        }

        if (!config.logGroupName) {
            errors.push('CloudWatch log group name is required');
        }
    }

    if (config.batchSize <= 0) {
        errors.push('Batch size must be greater than 0');
    }

    if (config.batchTimeout <= 0) {
        errors.push('Batch timeout must be greater than 0');
    }

    return errors;
};
